import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "hotel-teaser" }
const _hoisted_2 = ["href", "aria-label"]
const _hoisted_3 = ["src"]
const _hoisted_4 = {
  key: 0,
  class: "tags"
}
const _hoisted_5 = { class: "ratings" }
const _hoisted_6 = {
  key: 0,
  class: "rating-stars"
}
const _hoisted_7 = ["src"]
const _hoisted_8 = ["innerHTML"]
const _hoisted_9 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("article", _hoisted_1, [
    _createElementVNode("a", {
      href: _ctx.travel.url + _ctx.paramString,
      "aria-label": _ctx.pageTexts['hotelListPageSearchResultButtonShowHotel'] + ' ' + _ctx.travel.hotelName
    }, null, 8, _hoisted_2),
    _createElementVNode("div", null, [
      _createElementVNode("picture", null, [
        _createElementVNode("img", {
          src: _ctx.travel.image,
          alt: "",
          width: "540",
          height: "360",
          loading: "lazy"
        }, null, 8, _hoisted_3)
      ])
    ]),
    (_ctx.shuffledTags.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.shuffledTags.slice(0, 2), (tag, index) => {
            return (_openBlock(), _createElementBlock("span", { key: index }, _toDisplayString(tag.name), 1))
          }), 128))
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", null, [
      _createElementVNode("div", null, [
        _createElementVNode("div", _hoisted_5, [
          (_ctx.travel.hotelStars && _ctx.travel.hotelStars > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _createTextVNode(_toDisplayString(_ctx.travel.destination) + " ", 1),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.travel.hotelStars, (index) => {
                  return (_openBlock(), _createElementBlock("span", {
                    class: "icon-star",
                    key: index
                  }))
                }), 128))
              ]))
            : _createCommentVNode("", true),
          (_ctx.travel.tripadvisorRatingUrl)
            ? (_openBlock(), _createElementBlock("img", {
                key: 1,
                src: _ctx.travel.tripadvisorRatingUrl,
                alt: "Tripadvisor rating",
                width: "120",
                height: "20"
              }, null, 8, _hoisted_7))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("h2", null, _toDisplayString(_ctx.travel.hotelName), 1),
        _createElementVNode("div", {
          class: "rte",
          innerHTML: _ctx.travel.hotelShortDescription
        }, null, 8, _hoisted_8),
        (_ctx.travel.changedDaysDescription)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "rte notice",
              innerHTML: _ctx.travel.changedDaysDescription
            }, null, 8, _hoisted_9))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", null, [
        _createElementVNode("span", null, [
          _createElementVNode("strong", null, _toDisplayString(_ctx.priceInTotal), 1),
          _createElementVNode("span", null, _toDisplayString(_ctx.pricePerPerson), 1)
        ]),
        _createElementVNode("span", null, _toDisplayString(_ctx.pageTexts['hotelListPageSearchResultButtonShowHotel']), 1)
      ])
    ])
  ]))
}